import useStreamingMessageRequest from './useStreamingMessageRequest';

const useCreateMessage = (taskId?: string) => {
  const streamingMessageRequest = useStreamingMessageRequest();

  return async (
    formValues: any,
    onReceiveTextChunk: (chunk: string) => void,
    onReceiveToolCall: (name: string) => void,
  ): Promise<void> => {
    if (!taskId) throw new Error('Missing task ID');

    return streamingMessageRequest(
      'createTaskMessage',
      taskId,
      formValues,
      onReceiveTextChunk,
      onReceiveToolCall,
    );
  };
};

export default useCreateMessage;
